import { Builder, withChildren } from '@builder.io/react';
import React from 'react';

import { targetAttributeOptions } from '../../constants';
import {
  Button as ButtonComponent,
  ButtonProps,
} from '../../storyblocks-design-system/components/atoms/Button/Button';

interface ButtonBuilderProps extends ButtonProps {
  link?: string;
}

const Button = withChildren(function ({
  children,
  variant,
  className,
  size,
  disabled,
  link,
  target,
}: ButtonBuilderProps) {
  return (
    <ButtonComponent
      variant={variant}
      className={className}
      size={size}
      disabled={disabled}
      href={link}
      target={target}
    >
      {children}
    </ButtonComponent>
  );
});

Builder.registerComponent(Button, {
  name: 'Button SB',
  inputs: [
    {
      name: 'variant',
      type: 'string',
      defaultValue: 'primary',
      enum: [
        {
          label: 'primary',
          value: 'primary',
        },
        {
          label: 'secondary',
          value: 'secondary',
        },
        {
          label: 'outlined-dark',
          value: 'outlined-dark',
        },
        {
          label: 'outlined-light',
          value: 'outlined-light',
        },
        {
          label: 'text',
          value: 'text',
        },
        {
          label: 'alternate',
          value: 'alternate',
        },
      ],
    },
    {
      name: 'size',
      type: 'string',
      defaultValue: 'default',
      enum: [
        {
          label: 'default',
          value: 'default',
        },
        {
          label: 'large',
          value: 'large',
        },
      ],
    },
    {
      name: 'type',
      type: 'string',
      defaultValue: 'button',
      enum: [
        {
          label: 'button',
          value: 'button',
        },
        {
          label: 'submit',
          value: 'submit',
        },
      ],
    },
    {
      name: 'className',
      type: 'string',
      defaultValue: '',
    },
    {
      name: 'link',
      type: 'string',
      defaultValue: '',
    },
    {
      name: 'target',
      type: 'string',
      enum: targetAttributeOptions,
      defaultValue: '_blank',
      helperText:
        'https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-target',
      showIf: (options) => options.get('link'),
    },
  ],
  defaultChildren: [
    {
      '@type': '@builder.io/sdk:Element',
      component: { name: 'Text', options: { text: 'Text goes here.' } },
    },
  ],
});
